import Header from './components/Header';
import Hero from './components/Hero';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import FAQSection from './components/FAQSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <RankingSection />
        <CarouselSection />
        <AboutSection />
        <CommentsSection />
        <MediaSection />
        <ContactSection />
        <CardsSection />
        <AppSection />
        <IndexSection />
        <UpdatesSection />
        <FAQSection />
        <FeaturesSection />
        <TopicsSection />
      </main>
      <Footer />
    </>
  );
}